/* ============================================================
   CARINA — global.js
   Globale Initialisierung, Shopify Theme-Editor-Events
   ============================================================ */

'use strict';

// Utility: trap focus within an element
function trapFocus(element, eventToIgnore) {
  const focusable = Array.from(
    element.querySelectorAll(
      'button:not([disabled]), [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
    )
  ).filter((el) => !el.closest('[aria-hidden="true"]'));

  if (!focusable.length) return;
  const first = focusable[0];
  const last = focusable[focusable.length - 1];

  function handleKey(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  }
  element.addEventListener('keydown', handleKey);
  if (!eventToIgnore || e !== eventToIgnore) first.focus();
  return () => element.removeEventListener('keydown', handleKey);
}

// Utility: remove focus trap
function removeTrapFocus(element) {
  if (element) element.removeEventListener('keydown', trapFocus);
}

// Utility: pause all media
function pauseAllMedia() {
  document.querySelectorAll('video, audio').forEach((media) => {
    if (!media.paused) media.pause();
  });
}

// Utility: debounce
function debounce(fn, wait = 200) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn(...args), wait);
  };
}

// Utility: format money (Shopify-like)
function formatMoney(cents, format) {
  if (!format) format = window.Carina.moneyFormat || '{{amount}} €';
  const amount = (parseInt(cents, 10) / 100).toFixed(2).replace('.', ',');
  return format.replace('{{amount}}', amount);
}

// Expose utilities
window.Carina = window.Carina || {};
Object.assign(window.Carina, { trapFocus, removeTrapFocus, pauseAllMedia, debounce, formatMoney });

// Re-init on section load (Theme Editor)
document.addEventListener('shopify:section:load', (e) => {
  const section = e.target;
  // Re-init accordions
  section.querySelectorAll('[data-accordion]').forEach((el) => {
    if (typeof window.AccordionComponent !== 'undefined') {
      new window.AccordionComponent(el);
    }
  });
  // Re-init drawers
  section.querySelectorAll('[data-drawer]').forEach((el) => {
    if (typeof window.DrawerComponent !== 'undefined') {
      new window.DrawerComponent(el);
    }
  });
});

// Smooth scroll polyfill for anchor links
document.addEventListener('click', (e) => {
  const link = e.target.closest('a[href^="#"]');
  if (!link) return;
  const target = document.querySelector(link.getAttribute('href'));
  if (target) {
    e.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    target.focus({ preventScroll: true });
  }
});

// Announcement bar auto-rotate (if multiple blocks)
class AnnouncementBar extends HTMLElement {
  connectedCallback() {
    this.items = Array.from(this.querySelectorAll('[data-announcement-item]'));
    if (this.items.length <= 1) return;
    this.current = 0;
    this.delay = parseInt(this.dataset.delay || '4000');
    this.show(0);
    this.interval = setInterval(() => {
      this.current = (this.current + 1) % this.items.length;
      this.show(this.current);
    }, this.delay);
  }
  show(index) {
    this.items.forEach((item, i) => {
      item.hidden = i !== index;
      item.setAttribute('aria-hidden', String(i !== index));
    });
  }
  disconnectedCallback() { clearInterval(this.interval); }
}
if (!customElements.get('announcement-bar')) {
  customElements.define('announcement-bar', AnnouncementBar);
}
